import { useEffect, useCallback } from "react";
import { useBestInTravel } from "@context/bestInTravel/2025/bestInTravelContext";
import { CloseX } from "@icons";

import { Video } from "./video";

export function VideoModal() {
  const { videoOpen, closeVideoModal, video } = useBestInTravel();

  /**
   * When an overlay is open, disallow screen scrolling
   */
  // TODO - Review this useEffect
  useEffect(() => {
    const body = document.querySelector("body");
    const classes = "overflow-y-hidden";

    if (videoOpen) {
      body.classList.add(classes);
    }

    if (!videoOpen) {
      body.classList.remove(classes);
    }
  }, [videoOpen]);

  const handleVideoEsc = useCallback(
    e => {
      if (e.key === "Escape") {
        closeVideoModal();
      }
    },
    [closeVideoModal]
  );

  useEffect(() => {
    if (videoOpen) {
      window.addEventListener("keyup", handleVideoEsc);
    }

    if (!videoOpen) {
      window.removeEventListener("keyup", handleVideoEsc);
    }

    return () => window.removeEventListener("keyup", handleVideoEsc);
  }, [videoOpen, handleVideoEsc]);

  return (
    <div className="relative bg-black no-scrollbar">
      {videoOpen && (
        <div className="fixed top-0 left-0 z-50 w-full bg-black h-screen-dvh">
          <button
            type="button"
            aria-label="close video overlay"
            className="absolute top-0 right-0 z-10 flex items-center gap-2 px-4 py-1 m-4 text-xl font-semibold text-white bg-black rounded-pill"
            onClick={() => closeVideoModal()}
          >
            Close <CloseX className="text-md" />
          </button>
          <div className="flex flex-shrink w-full h-full">
            <Video data={video} />
          </div>
        </div>
      )}
    </div>
  );
}
